import { GrowthBook } from '@growthbook/growthbook-react';

export let growthBook: GrowthBook | undefined;

type TrackCallback = (event: string, properties?: Record<string, any>) => void;

export const initGrowthBook = async (trackCallback: TrackCallback) => {
  growthBook = new GrowthBook({
    apiHost: 'https://cdn.growthbook.io',
    clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: process.env.REACT_APP_ENV === 'development',
    navigateDelay: 0,
    trackingCallback: (experiment, result) => {
      trackCallback('Experiment Viewed', {
        experimentId: experiment.key,
        variationId: result.key,
      });
    },
  });
  await growthBook.init();
};
